module.exports = __webpack_public_path__ + "static/media/Progress3.f58fc344.png";